import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiInstance } from '../../Apis/Axios';
import { toast } from 'react-toastify';
import { t } from 'i18next';
import {errorCodeTranslation} from "../../Apis/ErrorCode";
import { WORK_SHIFT_SERVICE } from '../EndPoints';

// Create Work Shift Api's
export const CreateCompanyWorkShift = createAsyncThunk('companyWorkShift/CreateCompanyWorkShift', async (getVal) => {
    const result = await apiInstance
        .post(WORK_SHIFT_SERVICE.createCompanyWorkShift, { name: getVal })
        .then(function (response) {
            if (response.status == 201 || response.status == 200) {
                toast.success(t('has_been_created_successfully'));
            }
            return response;
        })
        .catch(function (error) {
            const errorMessage =
                error.response?.data?.code && errorCodeTranslation[error.response.data.code]
                    ? t(errorCodeTranslation[error.response.data.code])
                    : t('something_went_wrong_2');
            toast.error(errorMessage);
            return error.response;
        });

    const { data, status } = result;
    return { data, status };
});

export const CreateWorkShiftAccess = createAsyncThunk('companyWorkShift/CreateWorkShiftAccess', async (shiftList) => {
    const result = await apiInstance
        .post(WORK_SHIFT_SERVICE.createWorkShiftAccess, shiftList)
        .then(function (response) {
            if (response.status == 201 || response.status == 200) {
                toast.success(t('has_been_created_successfully'));
            }
            return response;
        })
        .catch(function (error) {
            const errorMessage =
                error.response?.data?.code && errorCodeTranslation[error.response.data.code]
                    ? t(errorCodeTranslation[error.response.data.code])
                    : t('something_went_wrong_2');
            toast.error(errorMessage);
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

export const GetAllWorkShifts = createAsyncThunk('companyWorkShift/GetAllWorkShifts', async (getVal) => {
    const result = await apiInstance
        .post(WORK_SHIFT_SERVICE.getAllWorkShifts, getVal)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            const errorMessage =
                error.response?.data?.code && errorCodeTranslation[error.response.data.code]
                    ? t(errorCodeTranslation[error.response.data.code])
                    : t('something_went_wrong_2');
            toast.error(errorMessage);
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

export const UserWorkSchedule = createAsyncThunk('companyWorkShift/UserWorkSchedule', async (params) => {
    const { id, UsercontractPagination } = params;
    const result = await apiInstance
        .post(`${WORK_SHIFT_SERVICE.userWorkSchedule}${id}`, UsercontractPagination)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            const errorMessage =
                error.response?.data?.code && errorCodeTranslation[error.response.data.code]
                    ? t(errorCodeTranslation[error.response.data.code])
                    : t('something_went_wrong_2');
            toast.error(errorMessage);
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

export const GetAllByWorkShiftId = createAsyncThunk('companyWorkShift/GetAllByWorkShiftId', async (workShiftId) => {
    const result = await apiInstance
        .get(`${WORK_SHIFT_SERVICE.getAllByWorkShiftId}${workShiftId}`)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            const errorMessage =
                error.response?.data?.code && errorCodeTranslation[error.response.data.code]
                    ? t(errorCodeTranslation[error.response.data.code])
                    : t('something_went_wrong_2');
            toast.error(errorMessage);
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

export const AddUserWithWorkShiftId = createAsyncThunk('companyWorkShift/AddUserWithWorkShiftId', async (params) => {
    const { id, all_user } = params;
    const result = await apiInstance
        .post(`${WORK_SHIFT_SERVICE.addUserWithWorkShiftId}${id}`, all_user)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

export const DeleteUserFromWorkShift = createAsyncThunk('companyWorkShift/DeleteUserFromWorkShift', async (params) => {

    const result = await apiInstance
        .post(WORK_SHIFT_SERVICE.deleteUserFromWorkShift,
            params,
        )
        .then(function (response) {
            if (response?.status == 201 || response?.status == 200) {
                toast.success(t('has_been_deleted_successfully').toUpperCase());
            }
            return response;
        })
        .catch(function (error) {
            const errorMessage =
                error.response?.data?.code && errorCodeTranslation[error.response.data.code]
                    ? t(errorCodeTranslation[error.response.data.code])
                    : t('something_went_wrong_2');
            toast.error(errorMessage);
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

export const DeleteContractFromWorkShift = createAsyncThunk(
    'companyWorkShift/DeleteContractFromWorkShift',
    async (params) => {
        const result = await apiInstance
            .post(WORK_SHIFT_SERVICE.deleteContractFromWorkShift, params)
            .then(function (response) {
                if (response?.status == 201 || response?.status == 200) {
                    toast.success(t('has_been_deleted_successfully').toUpperCase());
                }
                return response;
            })
            .catch(function (error) {
                const errorMessage =
                    error.response?.data?.code && errorCodeTranslation[error.response.data.code]
                        ? t(errorCodeTranslation[error.response.data.code])
                        : t('something_went_wrong_2');
                toast.error(errorMessage);
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

export const DeleteWorkSHiftTime = createAsyncThunk('companyWorkShift/deleteWorkShiftTime', async (id) => {
    const result = await apiInstance
        .delete(`${WORK_SHIFT_SERVICE.deleteWorkSHiftTime}${id}`)
        .then(function (response) {
            if (response.status == 201 || response.status == 200) {
                toast.success(t('has_been_deleted_successfully'));
            }
            return response;
        })
        .catch(function (error) {
            const errorMessage =
                error.response?.data?.code && errorCodeTranslation[error.response.data.code]
                    ? t(errorCodeTranslation[error.response.data.code])
                    : t('something_went_wrong_2');
            toast.error(errorMessage);
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

// Combined create: name + schedules + userIds + departmentIds in one body.
// Mirrors attendance CreateAttendanceShift / foodie create.
export const CreateWorkShiftFull = createAsyncThunk('companyWorkShift/createWorkShiftFull', async (params) => {
    const result = await apiInstance
        .post(WORK_SHIFT_SERVICE.createWorkShiftFull, params)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

// Combined update: name + userIds + departmentIds (schedules persisted apart).
export const UpdateWorkShiftFull = createAsyncThunk('companyWorkShift/updateWorkShiftFull', async (params) => {
    const result = await apiInstance
        .put(WORK_SHIFT_SERVICE.updateWorkShiftFull, params)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

// Shift detail by id for the update flow ({ id, name, schedules, users, departments }).
export const GetWorkShiftDetailById = createAsyncThunk('companyWorkShift/getWorkShiftDetailById', async (id) => {
    const result = await apiInstance
        .get(`${WORK_SHIFT_SERVICE.getWorkShiftDetailById}${id}`)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

// Not-assigned resources (update mode Add tab). Body:
// { pagination:{page,size}, model, resourceId, resourceString, key }.
export const GetWorkShiftResourceNotAssigned = createAsyncThunk('companyWorkShift/getWorkShiftResourceNotAssigned', async (body) => {
    const result = await apiInstance
        .post(WORK_SHIFT_SERVICE.getWorkShiftResourceNotAssigned, body)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

// Assigned resources (update mode Assigned tab + list detail expand). Body:
// { pagination:{page,size}, model, resourceId, resourceString } (key may be null).
export const GetWorkShiftResourceAssigned = createAsyncThunk('companyWorkShift/getWorkShiftResourceAssigned', async (body) => {
    const result = await apiInstance
        .post(WORK_SHIFT_SERVICE.getWorkShiftResourceAssigned, body)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

// details of provider employee
export const UpdateWorkShiftName = createAsyncThunk(
    'companyWorkShift/updateWorkShiftName',
    async (params, { dispatch, getState }) => {
        const result = await apiInstance
            .put(WORK_SHIFT_SERVICE.updateWorkShiftName, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                const errorMessage =
                    error.response?.data?.code && errorCodeTranslation[error.response.data.code]
                        ? t(errorCodeTranslation[error.response.data.code])
                        : t('something_went_wrong_2');
                toast.error(errorMessage);
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);
